/* Tabbed collection: switches product panels from the pill tabs (WAI-ARIA tabs pattern) */
if (!customElements.get('tabbed-collection')) {
  class TabbedCollection extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
      });

      // Theme editor: show the tab whose block is selected in the sidebar
      this.onBlockSelect = (event) => {
        const tab = this.tabs.find((t) => t.dataset.blockId === event.detail.blockId);
        if (tab) this.select(tab);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    select(tab, focus = false) {
      this.tabs.forEach((t) => {
        const selected = t === tab;
        t.setAttribute('aria-selected', selected);
        t.tabIndex = selected ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !selected;
      });
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      if (focus) tab.focus();
    }

    onKeydown(event, tab) {
      const index = this.tabs.indexOf(tab);
      const last = this.tabs.length - 1;
      let next;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      else return;
      event.preventDefault();
      this.select(this.tabs[next], true);
    }
  }

  customElements.define('tabbed-collection', TabbedCollection);
}
